import React, { useContext } from 'react';
import { OneLPSsdkParamsContext } from '../../onelps-sdk-params-context';
import styles from '../../css/components/common/tagline.css';
import { Trans } from 'react-i18next';
import {AppContext} from '../../Store';

const FALLBACK_KEY = 'bigbeat.herocity.odysseus.tagline';

function Tagline() {
	const onelpsParams = useContext(OneLPSsdkParamsContext);
	const [state] = useContext(AppContext);
	const isPrelanderActive = onelpsParams.preLander?.show && !state.preLanderCompleted;

	if (!onelpsParams.tagline?.show || isPrelanderActive) {
		return null;
	}

	const transKey = onelpsParams.tagline.translationKey || FALLBACK_KEY;
	const variantClass = styles[onelpsParams.bigbeat] || '';


	return (
		<h2 className={`${styles.tagline} ${variantClass}`} data-translation-key={transKey}>
			<Trans i18nKey={`translation:${transKey}`}>
				Now for a <span>short time</span>: Claim <span>FREE</span> Legendary <span>Tutankhamun</span> & fight <span>Anubis</span>!
			</Trans>
		</h2>
	);
}

export default Tagline;
